import styled, { css } from "styled-components";


interface PropsHeader {
  size: "small" |  "medium" | "large" | "display";
}

const sharedHeadingStyle = css<PropsHeader>`
  margin: 0;
  ${props => props.theme.heading.sizes[props.size]};
  ${props => props.theme.heading.sizes[props.size].mobile};
  @media(min-width: 768px) {
    ${props => props.theme.heading.sizes[props.size].tablet};
  }
  @media(min-width: 1366px) {
    ${props => props.theme.heading.sizes[props.size].laptop};
  }
  @media(min-width: 1440px) {
    ${props => props.theme.heading.sizes[props.size].desktop};
  }
`

export const HeadingH1 = styled.h1`
  ${sharedHeadingStyle}
`

export const HeadingH2 = styled.h2`
  ${sharedHeadingStyle}
`

export const HeadingH3 = styled.h3`
  ${sharedHeadingStyle}
`

export const HeadingH4 = styled.h4`
  ${sharedHeadingStyle}
`

export const HeadingH5 = styled.h5`
  ${sharedHeadingStyle}
`

export const HeadingH6 = styled.h6`
  ${sharedHeadingStyle}
`

export const Subtitle = styled.div`
  ${props => props.theme.subtitle.sizes.default};
  ${props => props.theme.subtitle.sizes.default.mobile};
  @media(min-width: 768px) {
    ${props => props.theme.subtitle.sizes.default.tablet};
  }
  @media(min-width: 1366px) {
    ${props => props.theme.subtitle.sizes.default.laptop};
  }
  @media(min-width: 1440px) {
    ${props => props.theme.subtitle.sizes.default.desktop};
  }
`

interface PropsParagraph {
  size: "small" |  "medium" | "large" | "display";
}

export const Paragraph = styled.p<PropsParagraph>`
  margin: 0;
  ${props => props.theme.paragraph.sizes[props.size]};
  ${props => props.theme.paragraph.sizes[props.size].mobile};
  @media(min-width: 768px) {
    ${props => props.theme.paragraph.sizes[props.size].tablet};
  }
  @media(min-width: 1366px) {
    ${props => props.theme.paragraph.sizes[props.size].laptop};
  }
  @media(min-width: 1440px) {
    ${props => props.theme.paragraph.sizes[props.size].desktop};
  }
`

export const Caption = styled.span`
  ${props => props.theme.caption.sizes.default};
  ${props => props.theme.caption.sizes.default.mobile};
  @media(min-width: 768px) {
    ${props => props.theme.caption.sizes.default.tablet};
  }
  @media(min-width: 1366px) {
    ${props => props.theme.caption.sizes.default.laptop};
  }
  @media(min-width: 1440px) {
    ${props => props.theme.caption.sizes.default.desktop};
  }
`

export const PageTitle = styled.p`
    margin: 3% 0px 1rem;
    font-size: 3.375rem;
    font-weight: 700;
    font-family: Inter, sans-serif;
    line-height: 1.1;
`

export const SubTitle24 = styled.p`
    font-size: 24px;
    font-weight: 500;
    font-family: Inter, sans-serif;
`

export const SubTitle20 = styled.p`
    font-size: 20px;
    font-weight: 500;
    font-family: Inter, sans-serif;
    margin: 0px;
    line-height: 32px;
`

export const SubTitle16 = styled.p`
    font-size: 16px;
    font-weight: 500;
    font-family: Inter, sans-serif;
    margin: 0px;
    line-height: 32px;
`

export const SubTitle12 = styled.p`
    font-size: 12px;
    font-weight: 500;
    font-family: Inter, sans-serif;
    margin: 0px;
    line-height: 32px;
`

export const SubTitle14 = styled.p`
    font-size: 14px;
    font-weight: 500;
    font-family: Inter, sans-serif;
    margin: 0px;
    line-height: 32px;
`

export const Title24 = styled.p`
    font-size: 24px;
    font-weight: 700;
    font-family: Inter, sans-serif;
`

export const Title18 = styled.p`
    font-size: 18px;
    font-weight: 700;
    font-family: Inter, sans-serif;
`